<template>
    <!-- <img src="../assets/reshot.svg" /> -->
    <span class="d-inline-block">
        <img class="w-100" v-if="(weather_code === '01d')" src="/weatherIcons/clear-day.svg" alt="">
        <img class="w-100" v-if="(weather_code === '01n')" src="/weatherIcons/clear-night.svg" alt="">
        <img class="w-100" v-if="(weather_code === '02d')" src="/weatherIcons/partly-cloudy-day.svg" alt="">
        <img class="w-100" v-if="(weather_code === '02n')" src="/weatherIcons/partly-cloudy-night.svg" alt="">
        <img class="w-100" v-if="(weather_code === '03d' || weather_code === '03n')" src="/weatherIcons/cloudy.svg" alt="">
        <img class="w-100" v-if="(weather_code === '04d' || weather_code === '04n')" src="/weatherIcons/overcast.svg" alt="">
        <img class="w-100" v-if="(weather_code === '09d' || weather_code === '09n')" src="/weatherIcons/drizzle.svg" alt="">
        <img class="w-100" v-if="(weather_code === '10d' || weather_code === '10n')" src="/weatherIcons/rain.svg" alt="">
        <img class="w-100" v-if="(weather_code === '11d' || weather_code === '11n')" src="/weatherIcons/thunderstorms.svg" alt="">
        <img class="w-100" v-if="(weather_code === '13d' || weather_code === '13n')" src="/weatherIcons/snow.svg" alt="">
        <img class="w-100" v-if="(weather_code === '50d' || weather_code === '50n')" src="/weatherIcons/mist.svg" alt="">
    </span>
</template>
<script>
export default {
    name:"weatherIcon",
    props: {
           weather_code:String,
           is_day:Number
    },
}
</script>